{
  "version": 1,
  "asset_id": "afa9c5c6-21fa-49c7-b69a-0ddfdb659a28",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/afa9c5c6-21fa-49c7-b69a-0ddfdb659a28/maintenance-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/afa9c5c6-21fa-49c7-b69a-0ddfdb659a28/maintenance-card.webp",
  "original_filename": "maintenance-card.webp",
  "size": 13016,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:02Z"
}
